import { appLoaded } from "../../app/async/asyncSlice";
import {getAuth, onAuthStateChanged} from 'firebase/auth';
import { dataFromSnapshot, getUserProfile, authClaimsReady } from "../../app/firestore/firestoreService";
import { listenToCurrentUserProfile } from "../profiles/profileSlice";
import { signInUser, signOutUser } from "./authSlice";
import { app } from "../../app/config/firebase";
import { onSnapshot } from '@firebase/firestore';

const auth = getAuth(app);

export function verifyAuth() {
  return function (dispatch) {
    // Tracks the current profile-doc listener so it can be torn down on
    // sign-out/re-sign-in instead of being left dangling - a dangling
    // listener re-evaluates security rules with no auth context once the
    // user signs out, which Firestore reports as an uncaught
    // permission-denied error in the console (no error handler was wired
    // up to catch it).
    let unsubscribeProfile = null;

    return onAuthStateChanged(auth, user => {
      if (unsubscribeProfile) {
        unsubscribeProfile();
        unsubscribeProfile = null;
      }

      if (user) {
        dispatch(signInUser(user))
        const profileRef = getUserProfile(user.uid);
        unsubscribeProfile = onSnapshot(
          profileRef,
          async snapshot => {
            dispatch(listenToCurrentUserProfile(dataFromSnapshot(snapshot)));
            // Wait for the auth-claims fetch (see firestoreService.js) so the
            // app isn't marked "initialized" - and OverallData's Firestore
            // listeners started - before authClaims is populated. Otherwise
            // those queries build with empty/default claims and get
            // permission-denied by Firestore rules, and never retry.
            await authClaimsReady;
            dispatch(appLoaded())
          },
          error => {
            if (error.code !== 'permission-denied') {
              console.warn('Profile snapshot listener error:', error);
            }
          }
        )
      } else {
        dispatch(signOutUser())
        dispatch(appLoaded())
      }
    })
  }
}